<template>
    <div>
      <!-- Sous 768 px le tableau passe en mode empilé et son en-tête (qui
           contient le bouton d'ajout version bureau) est masqué : on affiche
           alors le bouton au-dessus du tableau, avec son propre modal. -->
      <div class="d-md-none text-right mb-2">
        <ListModalAdd @ok="refreshAfterAdd" :id="id" :categories="categories" :host="host"
          modal-suffix="-Mobile" />
      </div>
      <div class="table-responsive datatable-vue" v-if="Data">
        <b-modal :ref="'alertdelete'+ArticlesID" title="Confirmation" @ok="deleteRow()">
          <p class="my-4">Are you sure to delete this List ? {{ selectArticlesID }}</p>
        </b-modal>
        <b-table
          ref="tableArticles"
          sticky-header
          striped
          hover
          responsive
          class="text-center"
          bordered
          head-variant="light"
          show-empty
          stacked="md"
          :items="Data"
          :fields="tablefields"
          :filter="filter"
          :current-page="currentPage"
          :per-page="perPage"
          @filtered="onFiltered"
          :select-mode="selectMode"
          :selectable="true"
        >
         <template v-slot:cell(firstIMG)="item" >
            <img
              height="50px"
              :src="item.item.images[0].src"
              width="50px"
            />
          </template>
          <template #cell(status)="field">
              <div
                v-if="field.item.status ===false"
                class="badge badge-glow badge-danger"
              >
                Disabled
              </div>
              <div
                v-if="field.item.status ===true"
                class="badge badge-glow badge-success"
              >
                Enabled
              </div>
          </template>
          <template v-slot:cell(actions)="item">
            <div class="row-actions">
              <span @click="getIndex(id)">
                <ListModalEdit @ok="refreshAfterEdit" :BlogID="id" :ArticleID="item.item.id" :Data="item.item" :categories="categories" :host="host"/>
              </span>
              <button type="button" class="icon-btn icon-btn-danger" title="Delete list" @click="onDelete(item.item.id)">
                <feather type="trash-2" size="16"></feather>
              </button>
            </div>
          </template>
          <template v-slot:head(actions)>
            <ListModalAdd @ok="refreshAfterAdd" :id="id" :categories="categories" :host="host"/>
          </template>
        </b-table>
      </div>
      <b-col md="12" class="my-1 pagination-justify p-0">
        <b-pagination
            v-model="currentPage"
            :total-rows="this.Data.length"
            :per-page="perPage"
            aria-controls="my-table"
            class="mt-4"
          ></b-pagination>
      </b-col>
    </div>
  </template>
  
  <script>
  import firebase from '@/utils/firestore-shim';
  import ListModalAdd from "./ListModalAdd.vue";
  import ListModalEdit from "./ListModalEdit.vue";
  export default {
    components:{ ListModalAdd, ListModalEdit },
    props: ["id","categories","currency","host"],
    data() {
      return {
        tablefields: [
          { key: "title", label: "Title", sortable: true },
          { key: "firstIMG", label: "Image", sortable: true },
          { key: "status", label: "Status", sortable: true },
          { key: "actions" }
        ],
        filter: null,
        totalRows: 1,
        currentPage: 1,
        perPage: 50,
        pageOptions: [10, 50, 100],
        item: "",
        selectArticlesID : "",
        index: null,
        selectMode: "single",
        Data:[],
        facebook:[],
        google:[]
      };
    },
    created() {
  
    },
    computed: {
      ArticlesID(){
        return this.id;
      },
      sortOptions() {
        return this.tablefields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key };
          });
      },
      selectedRows() {
        return this.listArticle.filter(item => item.delete);
      }
    },
    mounted() {   
      this.Data = this.getArticlesData();
    },
    methods: {
      getArticlesData() {
        let listData=[];
          var ArticlesRef = firebase.firestore().collection("Sites").doc(this.ArticlesID).collection("List")
          .get().then((e) => {
            e.forEach((doc) => {
              let element = {};
              element=doc.data();
              element.id = doc.id;
              listData.push(element);
            }); 
          });
          return listData;
      },
      getIndex(id) {
        this.selectArticlesID = id;
      },
      async deleteRow() {
        let fs = firebase.firestore();
        await fs.collection('Sites').doc(this.ArticlesID).collection("List").doc(this.selectArticlesID).delete().then(() => {
          this.Data = this.Data.filter((e) => e.id != this.selectArticlesID);
          this.$refs.tableArticles.refresh();
        }).catch(function(error) {
  
        });
      },
      onFiltered(filteredItems) {
        this.totalRows = filteredItems.length;
        this.currentPage = 1;
      },
      onSave(id) {
  
      },
      onDelete(id){
        this.selectArticlesID = id;
        this.$refs['alertdelete'+this.ArticlesID].show();
      },
      doCancel(id) {
  
      },
      addRecord() {
  
      },
      searchData() {
  
      },
      onEdit(id) {
  
      },
      refreshAfterAdd(e){
        this.Data.push(e);
        this.$refs.tableArticles.refresh(); 
      },
      refreshAfterEdit(){
        this.$refs.tableArticles.refresh();
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  table.text-center * {
    text-align: center;
  }
  </style>